export const SUGGESTION_ITEM_TEST_ID_PREFIX = 'search-suggestion-item-';
export const MODAL_SEARCH_SUGGESTIONS_TEST_ID = 'modalSearchSuggestions';
export const MODAL_SEARCH_SUGGESTIONS_CLOSE_BUTTON_TEST_ID =
  'modalSearchSuggestionsCloseButton';
export const SUGGESTIONS_LOADER_TEST_ID = 'suggestions-loader';
export const SUGGESTIONS_SHOW_ALL_BUTTON_TEST_ID =
  'suggestions-show-all-button';

export const migratedFields = ['iconSpacing', 'textSpacing'];
